import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as ValidateConstant from '../../../../constants/ValidateConstant';
import Button from '../../../../../common/components/Button';
import Options from '../../../../../common/components/Options';
import * as OrientationTypes from '../../../../../common/components/OrientationTypes';
import InputText from '../../../../../common/components/InputText';
import {GLOBAL, LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import {INPUTS} from '../../../../constants/MX/WizardInputs';
import * as InputTextTypes from '../../../../../common/components/InputTextTypes';
import {CreditHistoryStepProps, CreditHistoryStepState} from '../../../../types/mx/creditoReal/components';

const ERROR = '-Error';

class CreditHistoryStepView extends React.Component<CreditHistoryStepProps, CreditHistoryStepState> {
    constructor(props) {
        super(props);
        let creditCardOptselected = false;
        const bureauCatalogErrors = [];
        this.props.bureauOption.forEach((item) => {
            if (parseInt(item.id, 0) === this.props.bureauOptionIdCreditCardLastDigits && item.payload) {
                creditCardOptselected = true;
            }
            bureauCatalogErrors[item.id + ERROR] =
                item.payload !== undefined ? null : ValidateConstant.ERROR_SELECT_AN_ANSWER;
        });
        // @ts-ignore
        this.state = {
            ...bureauCatalogErrors,
            showErrors: false,
            showCreditCardLastDigits: creditCardOptselected,
            bureauOptionCreditCardLastDigits: props.bureauOptionCreditCardLastDigits ?
                null : ValidateConstant.ERROR_REQUIRED
        };
    }

    listBureauOptionError(bureauOption = []) {
        const bureauCatalogErrors = [];
        bureauOption.forEach((item) => {
            bureauCatalogErrors[item.id + ERROR] =
                item.payload !== undefined ? null : ValidateConstant.ERROR_SELECT_AN_ANSWER;
        });
        return bureauCatalogErrors;
    }

    componentDidUpdate(prevProps, prevState) {
        const bureauCatalogErrorsCuerrent = this.listBureauOptionError(this.props.bureauOption) || [];
        const bureauCatalogErrorsPrev = this.listBureauOptionError(prevProps.bureauOption) || [];
        const hasChanged = bureauCatalogErrorsCuerrent.some(([item, value]) => value !== bureauCatalogErrorsPrev[item]);

        if (hasChanged) {
            // @ts-ignore
            this.setState({
                ...bureauCatalogErrorsCuerrent
            });
        }
    }

    onChangeBureauOption = (value, error, id) => {

        const {bureauOptionIdCreditCardLastDigits, bureauOption} = this.props;

        const creditCardOptselected = parseInt(id, 10) === bureauOptionIdCreditCardLastDigits;

        const selected = bureauOption.find(x => x.id === id);
        selected.payload = value.payload;

        // @ts-ignore //Todo: Refactorizar [id + ERROR]: null para poder poner en typescript
        this.setState({
            [id + ERROR]: null,
            showCreditCardLastDigits: creditCardOptselected ? value.payload : this.state.showCreditCardLastDigits
        });

        this.props.onChangeBureauOptions(bureauOption);
        if (creditCardOptselected && !value.payload) {
            this.onChangeBureauOptionCreditCardLastDigits('',
                ValidateConstant.ERROR_REQUIRED, INPUTS.BUREAU_OPTION_CREDIT_CARD_LAST_DIGITS);
        }
    }

    onChangeBureauOptionCreditCardLastDigits = (value, error, inputId) => {
        this.setState({bureauOptionCreditCardLastDigits: error});
        this.props.onChangeBureauOptionCreditCardLastDigits(value, error, inputId);
    }

    validateFields = () => {
        let bureauOptionsValid = true;
        let creditCardOptselected = false;
        this.props.bureauOption.forEach((item) => {
            if (parseInt(item.id, 10) === this.props.bureauOptionIdCreditCardLastDigits && item.payload) {
                creditCardOptselected = true;
            }
            if (this.state[item.id + ERROR] !== null) {
                bureauOptionsValid = false;
            }
        });

        return bureauOptionsValid && ((creditCardOptselected &&
            this.state.bureauOptionCreditCardLastDigits === null) || !creditCardOptselected);
    }

    onPressNext = () => {
        if (this.validateFields()) {
            this.setState({showErrors: false});
            this.props.onPressNext();
        } else {
            this.setState({showErrors: true});
        }
    }

    render() {
        const {bureauOption} = this.props;
        const {showErrors, showCreditCardLastDigits} = this.state;
        return (
            <React.Fragment>
                <div className="row mb-3 d-none d-sm-none d-md-block">
                    <div className="col">
                        <h3 className="text-raleway text-secondary-lighten-1">{LOAN_APPLICATION_MX.CREDIT_HISTORY}</h3>
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col">
                        <p>{LOAN_APPLICATION_MX.CREDIT_HISTORY_SELECT_TEXT}</p>
                    </div>
                </div>

                <div className="row mb-2">
                    {bureauOption.map((item, index) => {
                        return (
                            <div className="col-lg-6 col-sm-12 mb-2" key={`option-${item.id}`}>
                                <Options id={item.id}
                                         name={item.id}
                                         label={item.value}
                                         options={item.booleanOptions}
                                         hasError={showErrors}
                                         required={true}
                                         orientation={OrientationTypes.HORIZONTAL}
                                         labelError={this.state[item.id + ERROR]}
                                         onChange={this.onChangeBureauOption}
                                         defaultValue={item.payload}/>
                            </div>

                        );
                    })}

                    {showCreditCardLastDigits && <div className="col-lg-6 col-sm-12 mb-2">
                        <InputText value={this.props.bureauOptionCreditCardLastDigits}
                                   id={INPUTS.BUREAU_OPTION_CREDIT_CARD_LAST_DIGITS}
                                   label={LOAN_APPLICATION_MX.CREDIT_CARD_LAST_NUMBERS}
                                   required={true}
                                   maxLength={4}
                                   minLength={4}
                                   hasError={showErrors}
                                   type={InputTextTypes.NUMBER}
                                   labelError={this.state.bureauOptionCreditCardLastDigits}
                                   onChange={this.onChangeBureauOptionCreditCardLastDigits}/>
                    </div>}
                </div>

                <div className="row mt-4 mb-3">
                    <div className="col-12 d-flex justify-content-between">
                        <Button text={GLOBAL.BACK} onPress={this.props.onPressBack} role="button"
                                customClass="left px-md-5 d-none d-md-block" type="outlined"/>
                        <Button text={LOAN_APPLICATION_MX.NEXT} onPress={this.onPressNext} role="button"
                                customClass="right px-md-5 btn-block"/>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default CreditHistoryStepView;